import React from 'react';
import AboutUsHero from 'components/about-us-page/hero';
import AboutUsFooter from 'components/about-us-page/footer';
import AwardCarousel from 'components/award-carousel';
import AboutUsStory from 'components/about-us-page/story';
import AboutUsReports from 'components/about-us-page/reports';
import AboutUsMediaCoverage from 'components/about-us-page/media-coverage';
import { aboutZooAwards } from 'constants/awards';
import styles from './style.module.scss';

import type { AboutUsContent } from 'data/named-content/types';

export default function AboutUs({ story = [], mediaCoverage = [], surveys = []}: AboutUsContent) {
  return (
    <div className={styles.component}>
      <AboutUsHero />
      <AboutUsStory story={story} />
      <AwardCarousel awards={aboutZooAwards} titleClassName={styles['awards-title']} />
      <AboutUsMediaCoverage mediaCoverage={mediaCoverage} />
      <AboutUsReports surveys={surveys} />
      <AboutUsFooter />
    </div>
  );
}
